import axios from "../libs/axios";

//获取验证码
export const getCode = (mobile) => {
  return axios.request({
    url: `/sms/sendCode/${mobile}`,
    method: "post"
  });
};

// 用户登录，获取token，并返回登录用户信息

export const getLogin = (param) => {
  return axios.request({
    params: param,
    url: `/users/login`,
    method: "post"
  });
};

// 获取所有商品分类 getAllGoodsType

export const getAllGoodsType = () => {
  return axios.request({
    url: `/goodsType/getAllGoodsType`,
    method: "get"
  });
};


// 获取首页商品信息

export const getHomePage = () => {
  return axios.request({
    url: `/goods/getHomePage`,
    method: "get"
  });
};

// 根据typeId 查询商品列表 /goods/singleTablePage

export const getGoodsList = (param) => {
  return axios.request({
    params: param,
    url: `/goods/singleTablePage`,
    method: "get"
  });
};

// 根据商品id获取详情 /goods/{id}

export const getGoodsDetail = (id) => {
  return axios.request({
    url: `/goods/${id}`,
    method: "get"
  });
};

// 获取省市区等地址信息 /address/getBscAreaList

export const getAddress = (param) => {
  return axios.request({
    params: param,
    url: `/address/getBscAreaList`,
    method: "get"
  });
};

// 获取店铺信息 /store/getRealStoreUnPageList
export const getStoreList = (param) => {
  return axios.request({
    params: param,
    url: `/store/getRealStoreUnPageList`,
    method: "get"
  });
};

// 积分兑换 /exchange/exchangeForSingle

export const exchangeGifts = (param) => {
  return axios.request({
    data: param,
    url: `/exchange/exchangeForSingle`,
    method: "post"
  });
};

// 获取登录用户信息 /users/getLoginUserInfo

export const getVipInfo = () => {
  return axios.request({
    url: `/users/getLoginUserInfo`,
    method: "get"
  });
};


// 获取所有订单消息 /order/getAllOrder

export const getOrderList = (param) => {
  return axios.request({
    params: param,
    url: `/order`,
    method: "get"
  });
};


// 获取兑换排行版 /goods/rankExchange/{topNum}

export const getTopNumList = (topNum) => {
  return axios.request({
    url: `/goods/rankExchange/${topNum}`,
    method: "get"
  });
};

// 查询新闻表列表 /news/singleTablePage

export const getNewsTypeList = (param) => {
  return axios.request({
    params: param,
    url: `/news/singleTablePage`,
    method: "get"
  });
};

// 查询单个新闻详情

export const getNewsDetails = (id) => {
  return axios.request({
    url: `/news/${id}`,
    method: "get"
  });
};